// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; 
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyA5D8OP-sq3r7LjKO8o1RpicFq04dAZliE",
    authDomain: "myprotfoliodatabase.firebaseapp.com",
    projectId: "myprotfoliodatabase",
    storageBucket: "myprotfoliodatabase.appspot.com",
    messagingSenderId: "301891714735",
    appId: "1:301891714735:web:d1adb10586c2a938ad5e5a",
    measurementId: "G-DQWXNMZHPF"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth()
const db = getFirestore(app); 
const storage = getStorage(app);

export { auth, app, db,storage };